module.exports = __webpack_public_path__ + "img/monitoring-application.8057e258.png";